import { createContext } from 'react';
import { User } from '@/types';
import { LoginResponse } from '@/services/authApi';

export interface AuthContextType {
  isAuthenticated: boolean;
  user: User | null;
  isLoading: boolean;
  login: (email: string, password: string, rememberMe?: boolean) => Promise<LoginResponse | void>;
  /** Authenticate with tokens obtained from an OAuth provider callback */
  loginWithToken: (accessToken: string, refreshToken?: string) => Promise<User>;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

